module.exports = __webpack_public_path__ + "img/bv-logo-grey.1225e062.svg";